import React from 'react';
import PropTypes from 'prop-types';

class Flap extends React.Component {

  constructor(props) {
    super(props);
    this.state = { height: '0px '};
  }

  componentDidMount() {
    this.updateState(this.props.open);
    setTimeout(()=> this.updateState(this.props.open), 800);
  }
  
  componentWillReceiveProps(nextProps) {
    const { open } = nextProps;
    this.updateState(open);
  }

  updateState(open){
    clearTimeout(this.timeout);
    this.setState(
      {height: !open ? '0' : this.getFlapHeight()}
    );
    // remove maxHeight after css animation is done
    if (this.props.resetHeight) {
      this.timeout = setTimeout(() => {
        if(this.props.open){
            this.setState(
              { height: '' }
            );
        }
      }, 500);
    }
  }

  setWrapperRef(el) {
    this.wrapper = el;
  }

  getFlapHeight() {
    return this.wrapper ? `${this.wrapper.getBoundingClientRect().height}px` : '10000px';
  }

  render() {
    const { children, headline, onChange, index, open } = this.props;
    return (
      <div className={open ? 'flap' : 'flap flap--collapsed'}>
        <button className="flap__headline" onClick={() => onChange ? onChange(index, open) : null}>
          <h4 className="headline headline--h4 ">{headline}</h4>
        </button>
        <div className="flap__content" style={{ maxHeight: this.state.height }}>
          <div className="flap__content-inner" ref={(el) => this.setWrapperRef(el)}>
            {children}
          </div>
        </div>
      </div>
    );
  }

}

Flap.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.object.isRequired,
  headline: PropTypes.string.isRequired,
  resetHeight: PropTypes.bool,
  index: PropTypes.number,
  onChange: PropTypes.func,
};

export default Flap;



// WEBPACK FOOTER //
// ./src/components/flap/Flap.js